import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { RecruitingModuleMenuService } from '@app/modules/applicant-tracker/services/menus/recruiting-module-menu.service';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { AuthService, NotifyService } from '@app/services';
import { ApplicantMessageTemplatesIndexTable } from '@applicant-tracker/services/tables/applicant-message-templates-table/applicant-message-templates-index.table';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';

@Component({
    templateUrl: './applicant-message-template-index.template.html',
    styleUrls: ['./applicant-message-template-index.style.scss'],
})
export class ApplicantMessageTemplateIndexView {
    @ViewChild('confirmDeleteApplicantMessageTemplateDialog')
    confirmDeleteApplicantMessageTemplateDialog: DeprecatedConfirmationDialogComponent;

    isLoading = false;

    constructor(
        public table: ApplicantMessageTemplatesIndexTable,
        private notify: NotifyService,
        private auth: AuthService,
        private router: Router,
        public recruitingModuleMenuService: RecruitingModuleMenuService
    ) {
        this.table.reload();
    }

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;
        const applicantMessageTemplate = data as ApplicantMessageTemplate;
        switch (menuItem.event) {
            case 'delete':
                this.onDelete(applicantMessageTemplate);
                break;
            case 'edit':
                this.router.navigate([
                    '/recruiting',
                    'templates',
                    'applicantMessageTemplates',
                    applicantMessageTemplate.id,
                ]);
                break;
        }
    }

    protected onDelete(applicantMessageTemplate: ApplicantMessageTemplate): void {
        this.confirmDeleteApplicantMessageTemplateDialog.description =
            'applicant-tracker.areYouSureYouWantToDeleteTheMessageTemplate';
        this.confirmDeleteApplicantMessageTemplateDialog.header = {
            key: 'applicant-tracker.deleteTemplateName',
            params: { templateName: applicantMessageTemplate.name },
        };

        this.confirmDeleteApplicantMessageTemplateDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;
            applicantMessageTemplate
                .param('company', this.auth.company.id)
                .delete()
                .then(() => {
                    this.table.reload();
                    this.notify.success('applicant-tracker.applicantMessageTemplateDeleted');
                    this.isLoading = false;
                });
        });
    }
}
